
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { SaberRekeyPayload } from '../entities/saber-rekey-v1/models';
import { axiosInstance } from "../axios-instance";

class SaberRekey {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queueSaberRekeyForADevice(input: SaberRekeyPayload): Promise<AxiosResponse<SaberRekeyPayload>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<SaberRekeyPayload>(`${this.baseUrl}/queueSaberRekey`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default SaberRekey;
